import {
  UPDATE_VALIDATION_CONTACT_US_PAGE,
  SUBMIT_CONTACT_US_REQUEST,
} from './constants'

import {
  toggleContactUsFormIsValid,
  submitContactUsDataSuccess,
  submitContactUsDataFailure,
} from './actions'

import { put, takeLatest, select, call } from 'redux-saga/effects'

import { getValidation, getContactUsFormData } from './selector'

import contactUsApi from '../../api/contactUsApi'
import { history } from '../..'
import { ROUTES } from '../../services/constants'

function* formValidation() {
  const validation = yield select(getValidation)
  const data = yield select(getContactUsFormData)
  const fields = validation.fields
  const validForm = Object.keys(fields).every((key) => {
    return fields[key] === ''
  })
  yield put(
    toggleContactUsFormIsValid({
      valid:
        validForm && !!data.ReCAPTCHA_Token && data.ReCAPTCHA_Token.length > 0,
    })
  )
}

function* submitContactUsData(action) {
  try {
    const { formValues } = action
    var payload = {
      FullName: formValues.FullName,
      RegistrationNumber: formValues.RegistrationNumber,
      PolicyNumber: formValues.PolicyNumber,
      TelephoneNumber: formValues.MobileNumber,
      Email: formValues.EmailAddress,
      Comment: formValues.CommentBox,
      ContactUsEnquiryType: formValues.EnquiryType,
      ReCaptcha: formValues.ReCAPTCHA_Token,
      Introducer: 'Confused',
    }

    yield call(
      contactUsApi.createContactUsRequest,
      'api/contactUs/create',
      payload
    )

    yield put(submitContactUsDataSuccess())
    yield* formValidation()
    history.push(ROUTES.CONTACT_US_THANK_YOU)
  } catch (e) {
    yield put(submitContactUsDataFailure())
  }
}

export default function* contactUsPageSaga() {
  yield takeLatest(UPDATE_VALIDATION_CONTACT_US_PAGE, formValidation)
  yield takeLatest(SUBMIT_CONTACT_US_REQUEST, submitContactUsData)
}
